module.exports = __webpack_public_path__ + "img/631c0b1.jpg";